import { Box, Typography, Link } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { Order } from '../../../Models';
import { usePrescriptionData } from '../../../services/api/queries/usePrescriptionData';

const COLUMNS = 4;

export default function FilesInfoSection({ row }: { row: Order }) {
    const { files } = usePrescriptionData(row);

    const getLinkText = (mimeType: string) => {
        if (mimeType === 'application/pdf') return 'PDF';
        if (mimeType.startsWith('image/')) return 'Imagen';
        if (mimeType === 'text/html') return 'Página web';
        return 'Archivo';
    };

    const ROWS = Math.max(2, Math.ceil(files.length / COLUMNS));

    // Transpose the list: group by column first
    const columns = Array.from({ length: COLUMNS }, (_, colIndex) =>
        Array.from({ length: ROWS }, (__, rowIndex) => {
            const fileIndex = colIndex * ROWS + rowIndex;
            return files[fileIndex] || null;
        }),
    );

    return (
        <Box overflow="auto">
            <Typography variant="subtitle1" gutterBottom>
                📑 Archivos del cliente
            </Typography>

            <Grid container spacing={2}>
                {columns.map((columnFiles, colIndex) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Grid xs={12 / COLUMNS} key={`col-${colIndex}`}>
                        {columnFiles.map((file, fileRowIndex) => {
                            if (!file) return null;
                            const fileIndex = colIndex * ROWS + fileRowIndex;

                            return (
                                <Typography
                                    key={file.storage_url || file.original_url}
                                    noWrap
                                    sx={{ textOverflow: 'ellipsis' }}
                                    variant="body2"
                                    gutterBottom>
                                    {fileIndex + 1}.{' '}
                                    <Link
                                        href={file.storage_url || file.original_url}
                                        target="_blank">
                                        {getLinkText(file.mime_type)}
                                    </Link>
                                </Typography>
                            );
                        })}
                    </Grid>
                ))}
            </Grid>

            {files.length === 0 && <Typography variant="body2">No hay archivos</Typography>}
        </Box>
    );
}
